import { DateTime } from 'luxon'

type LocalStorageThrottleParams = {
  key: string
  throttleWindowMs: number
}

/**
 * Runs callback only when allowed by the throttle window.
 * If recently triggered, callback is ignored.
 */
export const runWithLocalStorageThrottle = async (
  { key, throttleWindowMs }: LocalStorageThrottleParams,
  callback: () => void | Promise<void>,
): Promise<void> => {
  const now = DateTime.now().toMillis()

  try {
    const lastTriggeredAtRaw = localStorage.getItem(key)
    const lastTriggeredAt = parseInt(lastTriggeredAtRaw ?? '0', 0)

    if (now - lastTriggeredAt < throttleWindowMs) {
      return
    }

    localStorage.setItem(key, String(now))
    await callback()
  } catch {
    // If storage is unavailable (private mode, blocked storage), do not block execution.
    await callback()
  }
}
